const toMapByKey = <T extends Record<string, any>>(input: T[], key: keyof T) =>
  input.reduce(
    (accumulator, item) => ({ ...accumulator, [item[key]]: item }),
    {} as Record<string, T>,
  );

export default toMapByKey;
